export default __webpack_public_path__ + "static/1417-4d4888d73987e1acefaba5d45f6199e4.gif";